var React = require('react');

function ArrowsOutSimple (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 10.8608V24.0088H13","stroke":"white","strokeWidth":"1.875","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M23 14.1479L23 1L11 0.999999","stroke":"white","strokeWidth":"1.875","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowsOutSimple.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = ArrowsOutSimple;

ArrowsOutSimple.default = ArrowsOutSimple;
